export default "__VITE_ASSET__CFuVTheb__"